import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { useFetchRestaurantPicturesQuery, useFetchRestaurantQuery } from '@/api/hooks/useRestaurant';

import { Spinner } from '@/components/atoms/Spinner';
import { RestaurantPicturesGallery } from '@/components/organisms/RestaurantPicturesGallery';
import { TabPageLayout } from '@/components/templates/TabPageLayout';
import { Typography } from '@/components/atoms/Typography';
import { TbAlertCircle } from 'react-icons/tb';

export const PicturePage = () => {
  const { id } = useParams();
  const restaurantId = id || '';

  const { data: pictures, isLoading } = useFetchRestaurantPicturesQuery(restaurantId, { enabled: !!restaurantId });
  const { data: restaurant } = useFetchRestaurantQuery({ id: restaurantId, withMenu: false }, { enabled: !!restaurantId });

  if (isLoading || !pictures || !restaurantId || !restaurant) {
    return (
      <div className="flex flex-auto justify-center items-center h-48">
        <Spinner reverse={true} big />
      </div>
    );
  }

  const thereIsNoCertificate = !restaurant?.digitalCertificate?.suppliers || !restaurant.digitalCertificate?.company;

  return (
    <TabPageLayout id="header" firstTitle={'Photos de'} secondTitle={restaurant.name} restaurantId={restaurant.id}>
      {thereIsNoCertificate && (
        <Link
          to={`/restaurant/certificate/${restaurant.id}`}
          className="flex gap-2 hover:underline underline-offset-2 items-center bg-red-100 w-full rounded-xl p-3"
        >
          <TbAlertCircle size={32} className="text-[#E9001F]" />
          <Typography variant="h3" weight="medium" customColor="#E9001F">
            Cliquez ici pour ajouter votre certificat sur l'honneur pour pouvoir modifier vos photos.
          </Typography>
        </Link>
      )}
      <RestaurantPicturesGallery pictures={pictures} restaurantId={restaurantId} thereIsNoCertificate={thereIsNoCertificate} />
      {thereIsNoCertificate && (
        <Link
          to={`/restaurant/certificate/${restaurant.id}`}
          className="flex gap-2 hover:underline underline-offset-2 items-center bg-red-100 w-full rounded-xl p-3"
        >
          <TbAlertCircle size={32} className="text-[#E9001F]" />
          <Typography variant="h3" weight="medium" customColor="#E9001F">
            Cliquez ici pour ajouter votre certificat sur l'honneur pour pouvoir modifier vos photos.
          </Typography>
        </Link>
      )}
    </TabPageLayout>
  );
};
